const ChairishContext = window.chairisher.context;

/**
 * @returns {string} The URL to get and submit the marketing email form
 */
export function getMarketingEmailUrl() {
    return ChairishContext.MARKETING_EMAIL_URL;
}

/**
 * @returns {boolean} True indicates the marketing email modal is currently visible; false, if not
 */
export function isMarketingEmailModalVisible() {
    return !!ChairishContext.isMarketingEmailModalVisible;
}

/**
 * Updates the known visibility of the MarketingEmailModal
 *
 * @param {boolean} isVisible Whether the marketing email modal is currently visible
 */
export function setMarketingEmailModalVisible(isVisible) {
    ChairishContext.isMarketingEmailModalVisible = !!isVisible;
}
